<template>
    <div>
        <div class="modal hide fade" id="modalCustomerList" tabindex="-1" role="dialog" aria-labelledby="modalCustomerList" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Customer ({{ dataRaw.length }})
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row no-gutters">
                            <div class="col">
                                <input class="form-control-regular border-secondary border-right-0 rounded-0" type="search" value="search" v-model="searchQuery" @input="searchList" placeholder="Search by name">
                            </div>
                            <div class="col-auto">
                                <button class="btn btn-outline-secondary border-left-0 rounded-0 rounded-right" type="button" @click="refreshList"><i class="fa fa-search"></i></button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <button type="button" class="btn btn-primary mt-1 mb-1" style="width: 100%" data-toggle="modal" data-target="#modalCustomerForm" data-backdrop="static" data-keyboard="false">Create Customer</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <table class="table table-sm table-item table-striped table-hover">
                                    <thead>
                                        <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                                            <span>
                                            {{ t.name }}
                                            <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                            </span>
                                        </th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="c in filterData" :key="c.id">
                                            <td>{{ c.customer_no }}</td>
                                            <td>{{ c.name }}</td>
                                            <td>{{ c.phone }}</td>
                                            <td>{{ c.address }}</td>
                                            <td><button type="button" class="btn btn-sm btn-soft-primary" data-dismiss="modal" aria-label="Close" @click="select(c.id)">Select</button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <CustomerFormModal @createCustomer="createCustomer"/>
    </div>
</template>

<script>
import Axios from 'axios'
import { customerUrl, getHeader } from '../../config'
import CustomerFormModal from '@/components/point-of-sales/CustomerFormModal.vue'
export default {
  name: 'CustomerListModal',
  components: {
    CustomerFormModal
  },
  data () {
    return {
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Customer No.',
        prop: 'customer_no'
      }, {
        name: 'Name',
        prop: 'name'
      }, {
        name: 'Phone',
        prop: 'phone'
      }, {
        name: 'Address',
        prop: 'address'
      }]
    }
  },
  computed: {
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async createCustomer (value) {
      await Axios.post(customerUrl, value, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.refreshList()
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    async searchList () {
      var length = this.searchQuery.length
      var data = {}
      console.log(length)
      if (length > 3) {
        data = {
          name: this.searchQuery
        }
        Axios.post(customerUrl + '/list', data, { headers: getHeader() })
          .then(response => {
            console.log(response.data)
            this.dataRaw = response.data.data
          })
          .catch(error => {
            console.log(error.response)
          })
      } else if (length === 0) {
        data = {
          name: null
        }
        Axios.post(customerUrl + '/list', data, { headers: getHeader() })
          .then(response => {
            console.log(response.data)
            this.dataRaw = response.data.data
          })
          .catch(error => {
            console.log(error.response)
          })
      }
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    select: function (id) {
      var customer = this.dataRaw.find(d => d.id === id)
      this.$emit('select', customer)
    },
    refreshList () {
      var data = {
        name: this.searchQuery
      }
      Axios.post(customerUrl + '/list', data, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
        })
        .catch(error => {
          console.log(error.response)
        })
    }
  }
}
</script>
